module.exports = __webpack_public_path__ + "img/dis_yes2.41471956.png";